import type { LearningLessonPage, QuestionOption } from '../services/learningTypes';
import BasePageEditor from './BasePageEditor';

interface PageEditorProps {
    page: LearningLessonPage;
    pageNumber: number;
    onUpdate: (field: keyof LearningLessonPage, value: string | number) => void;
    onDelete: () => void;
    onSave?: () => Promise<void>;
    onConvertType?: () => void;
    saveStatus?: 'saved' | 'unsaved' | 'saving' | 'error';
}

export default function PageEditor({ page, pageNumber, onUpdate, onDelete, onSave, onConvertType, saveStatus }: PageEditorProps) {
    const handleUpdate = (field: keyof LearningLessonPage, value: string | number | boolean | QuestionOption[] | string[]) => {
        // For regular pages, we only expect string | number values
        if (typeof value === 'string' || typeof value === 'number') {
            onUpdate(field, value);
        }
    };

    return (
        <BasePageEditor
            page={page}
            pageNumber={pageNumber}
            pageType="Page"
            currentType="page"
            onUpdate={handleUpdate}
            onDelete={onDelete}
            onSave={onSave}
            onConvertType={onConvertType}
            saveStatus={saveStatus}
            markdownPreviewProps={{ isQuestionPage: false }}
            editorRows={24}
        />
    );
} 